module.exports = __webpack_public_path__ + "static/media/analise_conc.1e06db70.svg";